

const SectionHead = ({sectionName, icon, title}) => {
  return (
    <div className={`section__head ${sectionName}__head`}>
        <span>{icon}</span>
        <h2>{title}</h2>
    </div>
  )
}

export default SectionHead

// import SectionHead from '../SectionHead'
// <SectionHead sectionName="sectionName" icon={<ReactIconsTag/>} title="desiredTitle"/>